export enum DataCollectionPermissions {
  NewPlacemark= 2,
  DeletePlacemark,
  UpdatePlacemark
}
